import { OrthographicCamera } from 'three';
import { GROUND_UI_LAYER } from '../environment/ground-decal.js';
export const CAMERA_ZOOM_RANGE = { min: .5, max: 3 } as const; // At most three times the default view width and height.
/** The scenario viewer zooms freely; these bounds only keep the projection finite. */
export const FREE_ZOOM_RANGE = { min: .001, max: 1000 } as const;
// Negative near: zoomed out, the ground at the bottom of the screen lies behind the camera plane and would be clipped.
const NEAR = -400, FAR = 2500, DEEPEST_ZOOM = .08;
export function createIsometricCamera() {
  const camera = new OrthographicCamera(-20, 20, 14, -14, NEAR, FAR);
  camera.layers.enable(GROUND_UI_LAYER);
  camera.position.set(26, 26, 26); camera.lookAt(0, 0, 0); return camera;
}
/** Past 0.08× the ground at the top and bottom of the screen leaves the clip planes, so they widen with the view. Returns whether they changed. */
export function fitIsometricDepth(camera: OrthographicCamera) {
  const scale = Math.max(1, DEEPEST_ZOOM / camera.zoom);
  if (camera.near === NEAR * scale) return false;
  camera.near = NEAR * scale; camera.far = FAR * scale; return true;
}
export function resizeIsometricCamera(camera: OrthographicCamera, width: number, height: number) {
  if (!(width > 0 && height > 0)) return; // A hidden or not yet laid out host is 0 px: its aspect would make the frustum NaN.
  const aspect = width / Math.max(height, 1), halfHeight = Math.max(12.4, 19 / aspect);
  camera.left = -halfHeight * aspect; camera.right = halfHeight * aspect;
  camera.top = halfHeight; camera.bottom = -halfHeight; camera.updateProjectionMatrix();
}
